import { history } from 'modules/navigator';
import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Login from './login';
import Main from './main';
import OrderAdd from './orderAdd';
import OrderDetail from './orderDetail';
import User from './user';
import Password from './password';
import Accounts from './accounts';
import AccountAdd from './accountAdd';


class Router extends BrowserRouter {
  public history = history;
}

export default function SaleToolApp({ match }) {
  return (
    <Router>
      <Route
        path={`${match.path}/login`}
        component={Login}
      />
      <Route
        path={`${match.path}/main`}
        component={Main}
      />
      <Route
        path={`${match.path}/orderAdd`}
        component={OrderAdd}
      />
      <Route
        path={`${match.path}/orderDetail`}
        component={OrderDetail}
      />
      <Route
        path={`${match.path}/user`}
        component={User}
      />
      <Route
        path={`${match.path}/password`}
        component={Password}
      />
      <Route
        path={`${match.path}/accounts`}
        component={Accounts}
      />
      <Route
        path={`${match.path}/accountAdd`}
        component={AccountAdd}
      />
    </Router>
  );
}
